module.exports = __webpack_public_path__ + "static/media/bottlings12.ac524d3f.jpg";